import React, { useState, useContext } from 'react';
import { UserContext } from '../app/app';
import List from '../list/list';
import GiftEdit from '../gift-edit/gift-edit';

import { capitalize } from 'lodash-es';
import './user.scss';

const User = ({ name, email, userId, uuid, child, gifts }) => {
  const { currentUser } = useContext(UserContext);
  const [showNew, setShowNew] = useState(false);

  const showName = () => {
    if (
      currentUser &&
      currentUser.firstName.toLowerCase() === name.toLowerCase()
    ) {
      return 'My';
    } else {
      return capitalize(`${name}\u02bcs`);
    }
  };

  const toggleAdd = () => {
    setShowNew(!showNew);
  };

  const userButtons = () => {
    if (email !== currentUser.email) return null;

    return (
      <button className="button button-add" onClick={toggleAdd}>
        <span className="button-text">Add</span>
      </button>
    );
  };

  const renderEdit = () => {
    if (!showNew) return null;

    return (
      <GiftEdit
        close={toggleAdd}
        userId={userId}
        currentUser={currentUser}
      />
    );
  };

  return (
    <div>
      <h1 className="user-heading">{showName()} List</h1>
      {userButtons()}
      {renderEdit()}
      <List
        email={email}
        uuid={uuid}
        userId={userId}
        currentUser={currentUser}
        child={child}
        gifts={gifts}
      />
    </div>
  );
};

export default User;
